import { render, staticRenderFns } from "./parkvehicletyperule-form.vue?vue&type=template&id=b449fd12&scoped=true&"
import script from "./parkvehicletyperule-form.vue?vue&type=script&lang=js&"
export * from "./parkvehicletyperule-form.vue?vue&type=script&lang=js&"
import style0 from "./parkvehicletyperule-form.vue?vue&type=style&index=0&id=b449fd12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b449fd12",
  null
  
)

export default component.exports